import React from "react";
import { Table } from "reactstrap";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import MediaQuery from "react-responsive";

import style from "./Grid.module.scss";

const CashActivity = ({ activity, opsViewAccountName }) => (
  <MediaQuery minWidth={900}>
    {(matches) => (matches ? <TableDefault items={activity} opsViewAccountName={opsViewAccountName}/> : <TableSm items={activity} opsViewAccountName={opsViewAccountName}/>)}
  </MediaQuery>
);

const TableDefault = ({ items, opsViewAccountName }) => (
  <div className={style.grid}>
    <h6 className="my-3">Cash Activity</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th>Account</th>
          <th>Currency</th>
          <th style={{ minWidth: 110 }}>Balance type</th>
          <th className="text-right">Debit</th>
          <th className="text-right">Credit</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => {
          const credit = parseInt(item.CashActivityDebitCredit, 10) > 0 ? item.CashActivityVolume : "";
          const debit = parseInt(item.CashActivityDebitCredit, 10) > 0 ? "" : item.CashActivityVolume;
          return (
            <tr key={item.CashActivityId}>
              <td>
                <FormattedDate value={`${item.CashActivitySettlementDate}T00:00`} />
              </td>
              <td>{item.CashActivityDescription}</td>
              {opsViewAccountName == undefined ?
              (
                <td>{item.BasicAccountName}</td>
              )
              :
              (
                opsViewAccountName ?
                (
                  <td>{item.BasicAccountName}</td>
                )
                :
                (
                  <td>{item.BasicAccountNumber}</td>
                )
              )
              }
              <td>{item.CurrencyISO}</td>
              <td>{item.CashActivityBalanceType}</td>
              <td className="text-right">
                {debit != -1 ? <FormattedNumber value={debit} dataTypeDecimalName="currency" /> : "*****"}
              </td>
              <td className="text-right">
                {credit != -1 ? <FormattedNumber value={credit} dataTypeDecimalName="currency" /> : "*****"}
              </td>
            </tr>
          );
        })}
        {items.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Cash Activity
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

const TableSm = ({ items, opsViewAccountName }) => (
  <div className={style.grid}>
    <h6 className="my-3">Cash Activity</h6>
    <Table responsive hover>
      <thead>
        <tr>
          <th>Date</th>
          <th>Description - Account</th>
          <th>Balance type</th>
          <th className="text-right">Volume</th>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <tr key={item.CashActivityId}>
            <td>
              <FormattedDate value={`${item.CashActivitySettlementDate}T00:00`} />
            </td>
            <td>
              {item.CashActivityDescription}
              {opsViewAccountName == undefined ?
              (
                " - " + 
                <td>{item.BasicAccountName}</td>
              )
              :
              (
                opsViewAccountName ?
                (
                  " - " + 
                  <td>{item.BasicAccountName}</td>
                )
                :
                (
                  <td>{item.BasicAccountNumber}</td>
                )
              )
            }
            </td>
            <td>{item.CashActivityBalanceType}</td>
            <td className="text-right">
              <FormattedNumber value={item.CashActivityTotal} dataTypeDecimalName="currency" />
            </td>
          </tr>
        ))}
        {items.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No Cash Activity
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default CashActivity;
